import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router";

/**
 * Leaving a form without piling up history: Cancel (and Save, when editing) go
 * back to the page the player came from (the stuff's page, the map panel…)
 * instead of opening it again on top, so Back then leaves that page as expected.
 * Opened directly (a link, a new tab), they go to the fallback page instead.
 */
export function useLeave() {
  const navigate = useNavigate();
  const location = useLocation();
  // "default": the first page of this visit, nothing of ours behind it.
  const cameFromApp = location.key !== "default";
  const back = useCallback(
    (fallback: string) => {
      if (cameFromApp) navigate(-1);
      else navigate(fallback, { replace: true });
    },
    [cameFromApp, navigate],
  );
  /** After saving something new: its page takes the form's place in history. */
  const to = useCallback((target: string) => navigate(target, { replace: true }), [navigate]);
  return { back, to, cameFromApp };
}
